import { render, staticRenderFns } from "./SectionalTimeRank.vue?vue&type=template&id=54ac76fa&scoped=true"
import script from "./SectionalTimeRank.vue?vue&type=script&lang=js"
export * from "./SectionalTimeRank.vue?vue&type=script&lang=js"
import style0 from "./SectionalTimeRank.vue?vue&type=style&index=0&id=54ac76fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ac76fa",
  null
  
)

export default component.exports